import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { CreateClientData, Client } from '../../api/clientApi';
import ClientForm from '../Forms/ClientForm';

interface ClientFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  formData: CreateClientData;
  onFormChange: (data: CreateClientData) => void;
  isEdit?: boolean;
  editingClient?: Client | null;
}

const ClientFormModal: React.FC<ClientFormModalProps> = ({
  isOpen,
  onClose,
  formData,
  onFormChange,
  isEdit = false,
  editingClient = null,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{isEdit ? 'Edit Client' : 'Create New Client'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <ClientForm
            formData={formData}
            setFormData={onFormChange}
            onClose={onClose}
            isEdit={isEdit}
            editingClient={editingClient}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ClientFormModal;
